export type Breadcrumb = {
  title: string;
  path: string;
};

export const createBreadcrumb = (title: string, path: string): Breadcrumb => ({
  title,
  path,
});
